/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface PersonProps {
  color?: string
  size?: string
  className?: string
}

const IconSingleUser = (props: PersonProps) => {
  const { className = '', color = '#364152' } = props

  return (
    <span className={'flex items-center justify-center' + className}>
      <svg
        width={22}
        height={22}
        viewBox="0 0 20 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.40002 20.5124C2.40002 16.7369 5.55431 13.6762 12 13.6762C18.4457 13.6762 21.6 16.7369 21.6 20.5124C21.6 21.1131 21.1618 21.6 20.6212 21.6H3.37885C2.83826 21.6 2.40002 21.1131 2.40002 20.5124Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M15.6 6.00002C15.6 7.98825 13.9882 9.60002 12 9.60002C10.0118 9.60002 8.40002 7.98825 8.40002 6.00002C8.40002 4.0118 10.0118 2.40002 12 2.40002C13.9882 2.40002 15.6 4.0118 15.6 6.00002Z"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    </span>
  )
}

export default IconSingleUser
